import {
	ADD_COMPANIES
} from "../constants"

const initialState = {
	items: []
};

export const CompaniesReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
		case ADD_COMPANIES :

			action.payload.companies.forEach( ( company ) => {
				state = {
					...state,
					items: [
						...state.items,
						{
							key: company.key,
							name: company.val().title
						}

					]
				}
			} );
			break;

		default:

			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/companies.js